import React from 'react';
import './filter.css';
import { formatName } from '../../utils/spaUtils';

const ResetFilters = (props) => {
    let { services, actions } = props;
    //this.actions = actions;
    let { filter } = services;
    const banner = getFilterBanner(filter, actions);
    if (!banner) {
        return null;
    }
    return (
        <div className='selected-filter-banner' >
            <div className='filter-reset-content '>
                {banner}
            </div>
        </div>
    )
}

const getFilterBanner = (filter, actions) => {
    if (!filter || filter.length <= 0)
        return false;
    if (!filter.selectedGuest && !filter.selectedCategory && !filter.selectedDate && !filter.selectedBenefit)
        return false;
    return (<div className='banner-text-container row'>
        <span className='font-size-p0 gotham-bold' data-test-id="your-selections">Your selections: </span>
        <ul className='list-style row no-pad-margin'>
            {(filter.selectedCategory) ?
                <li>
                    <button aria-label={`Remove ${filter.selectedCategory} category from selections`} className='banner-text button-link font-size-p0 gotham-book title-hover' onClick={resetFilter.bind(this, 'selectedCategory', actions)}>
                        <svg focusable="false" className="svg-icon svg-icon-close-x"> <use xlinkHref="#icon-close-x" data-test-id="close-icon" ></use></svg>
                        <span data-test-id="service-name-label">  {filter.selectedCategory}</span>
                    </button> </li> : null
            }

            {(filter.selectedDate) ?
                <li><button aria-label={`Remove ${filter.selectedDate} , ${filter.selectedTimeSlot || ''} from selections`} className='banner-text button-link font-size-p0 gotham-book' onClick={resetFilter.bind(this, 'selectedDate', actions)}>
                    <svg focusable="false" className="svg-icon svg-icon-close-x"> <use xlinkHref="#icon-close-x" ></use></svg>
                    <span data-test-id="selected-date-label" >{`${filter.selectedDate} ${filter.selectedTimeSlot || ''}`}</span>
                </button></li>
                : null
            }

            {(filter.selectedBenefit) ?
                <li><button aria-label={`Remove ${filter.selectedBenefit} benefit from selections`} className='banner-text button-link font-size-p0 gotham-book' onClick={resetFilter.bind(this, 'selectedBenefit', actions)}>
                    <svg focusable="false" className="svg-icon svg-icon-close-x"> <use xlinkHref="#icon-close-x" ></use></svg>
                    <span data-test-id="selected-benefit-label"> {filter.selectedBenefit} </span>
                </button></li> : null
            }

            {(filter.selectedGuest) ?
                <li><button aria-label={`Remove ${filter.selectedGuest} from selections`} className='banner-text button-link font-size-p0 gotham-book' onClick={resetFilter.bind(this, 'selectedGuest', actions)}>
                    <svg focusable="false" className="svg-icon svg-icon-close-x"> <use xlinkHref="#icon-close-x" ></use></svg>
                    <span data-test-id="selected-guest-label"> {formatName(`${filter.selectedGuest}`)}</span>
                </button></li> : null
            }

            <li><button aria-label={`Reset all selections`} className='banner-text button-link font-size-p0 gotham-book reset-filter' onClick={resetFilter.bind(this, 'All', actions)} data-test-id="reset-filter">
                <svg focusable="false" className="svg-icon svg-icon-refresh"> <use xlinkHref="#icon-refresh" data-test-id="undo-icon" ></use></svg> Reset Filters </button> </li>

        </ul>
    </div>)

}

const resetFilter = (type, actions) => {
    actions.resetFilter(type);
}
export default ResetFilters;